import {Injectable} from '@angular/core';
import {BaseSearchDao} from '../../../../../base-search-dao';
import {KluhManagerValidator} from '../../../../../validators/kluh-manager-validator';
import {Observable} from 'rxjs/internal/Observable';
import {VpnMonitoringStatus} from '../../../../../models-monitoring';
import {ServerType} from '../../../../../models';
import {R2CloudHttpMonitoringService} from '../../../../../r2-cloud-http-monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class VpnMonitoringStatusDaoService extends BaseSearchDao<VpnMonitoringStatus> {
    constructor(http: R2CloudHttpMonitoringService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'vpn-monitoring-status');
    }

    findAllByServerIdAndServerType(serverId: number, serverType: ServerType): Observable<VpnMonitoringStatus[]> {
        return this.http.get<VpnMonitoringStatus[]>(this.url + '/find-all-by-server-id-and-server-type/' + serverType + '/' + serverId);
    }
}
